import {ReposHeaderRefSelector} from '@github-ui/code-view-shared/components/ReposHeaderRefSelector'
import {ArrowUpIcon} from '@primer/octicons-react'
import type {ButtonProps} from '@primer/react'
import {Box, Button} from '@primer/styled-react'
import {clsx} from 'clsx'

import styles from './FileNameStickyHeader.module.css'
import {ReposHeaderBreadcrumb} from './ReposHeaderBreadcrumb'

const StickyReposHeaderBreadcrumb = () => {
  // additional ids to create unique ids for axe
  return <ReposHeaderBreadcrumb id="sticky-breadcrumb" fileNameId="sticky-file-name-id" fontSize={1} />
}

const GoToTopButton = ({sx, className}: {sx?: ButtonProps['sx']; className?: string}) => {
  return (
    <Button
      leadingVisual={ArrowUpIcon}
      variant="invisible"
      size="small"
      sx={sx}
      onClick={event => {
        event.preventDefault()
        window.scrollTo({top: 0, behavior: 'smooth'})
      }}
      className={clsx(styles.Button, className)}
    >
      Top
    </Button>
  )
}

export default function FileNameStickyHeader({
  isStickied,
  showTree,
  treeToggleElement,
}: {
  isStickied: boolean
  showTree: boolean
  treeToggleElement: React.ReactElement | null
}) {
  const stickySx = isStickied
    ? {
        backgroundColor: 'canvas.subtle',
        borderLeft: '1px solid var(--borderColor-default, var(--color-border-default))',
        borderRight: '1px solid var(--borderColor-default, var(--color-border-default))',
      }
    : {}

  return (
    <Box
      sx={{
        display: isStickied ? 'flex' : 'none',
        minWidth: 0,
        py: 2,
        ...stickySx,
      }}
    >
      {!showTree ? (
        <div className={styles.Box_1}>
          <div className={styles.Box_2}>
            {isStickied && treeToggleElement}
            <div className={styles.Box_3}>
              <ReposHeaderRefSelector buttonClassName="ref-selector-class" />
            </div>
            <div className={styles.Box_4}>
              <StickyReposHeaderBreadcrumb />
            </div>
          </div>
          <GoToTopButton className={styles.GoToTopButton} />
        </div>
      ) : (
        <div className={styles.Box_5}>
          <StickyReposHeaderBreadcrumb />
          <GoToTopButton className={styles.GoToTopButton} />
        </div>
      )}
    </Box>
  )
}

try{ StickyReposHeaderBreadcrumb.displayName ||= 'StickyReposHeaderBreadcrumb' } catch {}
try{ GoToTopButton.displayName ||= 'GoToTopButton' } catch {}
try{ FileNameStickyHeader.displayName ||= 'FileNameStickyHeader' } catch {}